import React, { useState, useRef, useEffect } from "react";
import { UnoStoreHooks, UiComponents, initialize } from "@simulanisindia/ui";
import Functions from "./Functions";
import Layers from "./Layers";
import { LayersIcon } from "../../../assets/icons/icons";
import { HOTSPOT, SCENE } from "../../../constant/constant";
import apiclient from "../../../apiclient";
import { PROJECT_INVENTORY } from "../../../apiclient/apiEndpoints";

const { useUnoSelector } = UnoStoreHooks;

const Toolbar = ({animateToHotspotPosition,  showLibrary, setShowLibrary, projectId, visible, scene, setScene, currentHotspot, setCurrentHotspot, fetchSceneDetails, createNewHotspot , setSelectMode, reloadScene}) => {
  const configData = useUnoSelector((state) => state.config);

  const [openSceneHierarchy, setOpenSceneHierarchy] = useState(true);
  const [activeTab, setActiveTab] = useState(null);

  const handleSelect = (type) => {
    if (type === SCENE && scene.hasOwnProperty("uuid")) {
      setActiveTab(pre => pre === type ? null : type)
    } else if (type === HOTSPOT && currentHotspot.hasOwnProperty("uuid")) {
      setActiveTab(pre => pre === type ? null : type)
    }
  }

  return (
    <>
      <div className={`toolbarMain ${visible ? "visible" : "hidden"}`}>
        <div className={`toolbarMainItem layer ${openSceneHierarchy ? "active" : ""}`}>
          <div className="toolbarItemHead" onClick={() => setOpenSceneHierarchy(pre => !pre)}>
            <span className="arrowIcon">
              <LayersIcon />
            </span>
            <p>Scene Hierarchy</p>
          </div>
          <Layers animateToHotspotPosition={animateToHotspotPosition} currentHotspot={currentHotspot} setSelectMode={setSelectMode} setActiveTab={setActiveTab} showLibrary={showLibrary} setShowLibrary={setShowLibrary} projectId={projectId} scene={scene} setScene={setScene} fetchSceneDetails={fetchSceneDetails} setCurrentHotspot={setCurrentHotspot} createNewHotspot={createNewHotspot} />
        </div>

        {(scene.hasOwnProperty("uuid") && scene["uuid"]) &&
          <div className={`toolbarMainItem ${activeTab === SCENE ? " active SingleTabOPen" : ""}`} >
            <div className="toolbarItemHead" onClick={() => handleSelect(SCENE)}>
              <span className="arrowIcon"> <LayersIcon /> </span>
              <p>Scene Configuration</p>
            </div>
            <Functions animateToHotspotPosition={animateToHotspotPosition} scene={scene} setScene={setScene} activeTab={activeTab} />
          </div>
        }

        {currentHotspot.hasOwnProperty("uuid") &&
          <div className={`toolbarMainItem ${activeTab === HOTSPOT ? "active SingleTabOPen" : ""}`} >
            <div className="toolbarItemHead" onClick={() => handleSelect(HOTSPOT)}>
              <span className="arrowIcon">  <LayersIcon />  </span>
              <p>Hotspot Configuration</p>
            </div>
            <Functions animateToHotspotPosition={animateToHotspotPosition} reloadScene={reloadScene} scene={scene} setScene={setScene} activeTab={activeTab} currentHotspot={currentHotspot} setCurrentHotspot={setCurrentHotspot} />
          </div>
        }


      </div>
    </>
  );
};

export default Toolbar;
